import { useEffect, useState, useRef, useCallback } from 'react';

export const useElementPosition = () => {
  const [position, setPosition] = useState<{ top: number; bottom: number; left: number; right: number }>({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  });
  const elementRef = useRef<HTMLDivElement>(null);

  const updatePosition = useCallback(() => {
    if (elementRef.current) {
      const { offsetTop, offsetHeight, offsetLeft, offsetWidth } = elementRef.current;
      const top = offsetTop;
      const bottom = offsetTop + offsetHeight;
      const left = offsetLeft;
      const right = offsetLeft + offsetWidth;
      setPosition({ top, bottom, left, right });
    }
  }, []);

  useEffect(() => {
    if (!elementRef.current) {
      return () => {};
    }

    const resizeObserver = new ResizeObserver(updatePosition);
    resizeObserver.observe(elementRef.current);

    const mutationObserver = new MutationObserver(updatePosition);
    mutationObserver.observe(elementRef.current, { attributes: true, childList: true, subtree: true });

    updatePosition();

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [updatePosition]);

  return { elementRef, position, updatePosition };
};
